// @flow
import {baseGuideValidators} from '../guideHelpers/baseGuide.validators';

export const validators = {
  ...baseGuideValidators
};
